//roles
export const SUPER_ADMIN = state => {   
    if(state.user == "superadmin"){
        return true;
    }
}

export const ADMIN = state => {   
    if(state.user == "admin"){
        return true;
    }
}

export const USER = state => {   
    if(state.user == "user"){
        return true;
    }
}